import React from "react";
import { ErrorStateProps } from "./types";
import { Loader2, AlertTriangle, CheckCircle } from "lucide-react";

export const LoadingState: React.FC = () => (
    <div className="text-center py-12 px-4 bg-white dark:bg-neutral-900 rounded-xl border border-neutral-200 dark:border-neutral-800">
        <Loader2 size={36} className="animate-spin text-indigo-500 mb-4 inline-block" />
        <p className="text-neutral-500 dark:text-neutral-400 text-base m-0">Loading sanctions lists...</p>
    </div>
);

export const ErrorState: React.FC<ErrorStateProps> = ({ error }) => (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4 text-red-600">
        <div className="flex items-center gap-2 mb-2">
            <AlertTriangle size={20} />
            <strong>Error Loading Sanctions Lists</strong>
        </div>
        <p className="m-0 text-sm">{error}</p>
        {error.includes('404') && (
            <p className="mt-2 mb-0 text-sm italic">
                No sanctions found for this customer, or the API endpoint is not available.
            </p>
        )}
    </div>
);

export const EmptyState: React.FC = () => (
    <div className="bg-neutral-50 dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-lg p-6 text-center text-neutral-500 dark:text-neutral-400">
        <CheckCircle size={30} className="mb-2 text-green-500 inline-block" />
        <p className="m-0 font-medium">No Sanctions Lists Found</p>
        <p className="mt-2 mb-0 text-sm">
            This customer is not currently on any sanctions lists.
        </p>
    </div>
);

